import * as React from 'react';

import * as TimeUtils from '@acceligentllc/shared/utils/time';

import { TimePeriodRecurrence } from '@acceligentllc/shared/enums/timePeriodRecurrence';

import DateFilter from 'af-components/Table/Filters/DateFilter';

type Props = {
	setStartDate: (value: Date) => void;
	startDate: Date;
	setEndDate: (value: Date) => void;
	endDate: Date;
	setPeriod: (value: TimePeriodRecurrence) => void;
	period: TimePeriodRecurrence;
	fiscalYearStartMonth: Nullable<number>;
};
const ReportTypeViewTableDateFilter: React.FC<Props> = ({ setEndDate, setPeriod, setStartDate, endDate, period, startDate, fiscalYearStartMonth }) => {

	const changePeriod = React.useCallback((newPeriod: TimePeriodRecurrence, selected: Date) => {
		let from: Date = selected, to: Date = selected;

		switch (newPeriod) {
			case TimePeriodRecurrence.MONTHLY:
				from = TimeUtils.positionDate(from, 'start', 'month');
				to = TimeUtils.positionDate(to, 'end', 'month');
				break;
			case TimePeriodRecurrence.WEEKLY:
				from = TimeUtils.positionDate(from, 'start', 'week');
				to = TimeUtils.positionDate(to, 'end', 'week');
				break;
			case TimePeriodRecurrence.YEAR_TO_DATE:
				from = TimeUtils.positionDate(new Date(), 'start', 'year');
				to = new Date();
				break;
			case TimePeriodRecurrence.LAST_6_MONTHS:
				const _endDate = new Date();
				const _startDate = new Date();
				const day = _endDate.getDate();
				let month = _startDate.getMonth() - 6;
				let year = _startDate.getFullYear();

				if (month < 0) {
					month += 12;
					year -= 1;
				}

				const lastDayOfTarget = new Date(year, month + 1, 0).getDate(); // if we put 0 as date argument, we get the last day index of previous month
				const newDay = Math.min(day, lastDayOfTarget);

				_startDate.setFullYear(year, month, newDay);

				from = _startDate;
				to = _endDate;
				break;
			case TimePeriodRecurrence.FISCAL_YEAR:
				if (fiscalYearStartMonth === null) {
					break;
				}
				const fiscalMonth = fiscalYearStartMonth;
				const selMonth = selected.getMonth() + 1;
				let fyYear = selected.getFullYear();

				if (selMonth < fiscalMonth) {
					fyYear -= 1;
				}

				const fyStart = new Date(fyYear, fiscalMonth, 0);
				const fyEnd = new Date(fyYear + 1, fiscalMonth - 1, 0);
				from = TimeUtils.positionDate(fyStart, 'start', 'month');
				to = TimeUtils.positionDate(fyEnd, 'end', 'day');
				break;
			case TimePeriodRecurrence.DAILY:
			case TimePeriodRecurrence.CUSTOM:
			default:
				break;
		}

		setPeriod(newPeriod);
		setStartDate(from);
		setEndDate(to);
	}, [fiscalYearStartMonth, setEndDate, setPeriod, setStartDate]);

	const filterByDate = React.useCallback((_startDate: Date, _endDate: Date) => {
		setStartDate(TimeUtils.positionDate(_startDate, 'start', 'day'));
		setEndDate(TimeUtils.positionDate(_endDate, 'end', 'day'));
	}, [setEndDate, setStartDate]);

	return (
		<DateFilter
			changePeriod={changePeriod}
			endDate={endDate}
			onChange={filterByDate}
			period={period}
			startDate={startDate}
		/>
	);
};

export default React.memo(ReportTypeViewTableDateFilter);

